export const API_URL = process.env.REACT_APP_API_URL;
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
export const NETWORK_CHAIN_IDS = process.env.REACT_APP_NETWORK_CHAIN_IDS;
